
  import App from './App.vue'
  import  LogoutComponent  from "./components/LogoutComponent.vue";
  import ActivateEingabe from "./components/Navigation/ActivateEingabe.vue";
  import { db } from "./db";
  import { AppStates } from "@/models/AppStates";
  import { AppUsers } from "@/models/AppUsers";
  import { DataSafe } from "@/models/DataSafe";
  import { useObservable, from  } from "@vueuse/rxjs";
  import { liveQuery } from "dexie";
  import { watch,ref } from 'vue'
  import WebWorker from "./components/WebWorker.vue";
  import emmieSiteLogo from '@/components/LogoComponent.vue';
  
  export default {
    components:{
      LogoutComponent,
      WebWorker,
      emmieSiteLogo,
      ActivateEingabe
    },
    data: () => ({
      absolute: true,
      opacity: 1,
      deletedialog:false,
      dayPropertiesDialog: false,
      
      isUser:{ 
        name:"",
        sysId: "",
        password: "",
        dataBackend: "",
        id:0,
      }
    }),
    methods:{
        /* @ts-ignore */
      getName(User){
        if(typeof User.name != 'undefined'){
          return User.name;
        }
      },
      hasBackend(User: any){
        if(typeof User != 'undefined'){
          return AppUsers.hasBackend(User);
        }
      },
      async deleteData (){
         return await AppUsers.getMyUser().then((user) => {
          //console.log('startdetelete')
           DataSafe.deleteData(user.sysId).then(() => {
            this.refreshCode();
          })
        })
        
      },
      refreshCode(){
        window.location.reload()
      },
    },
    setup() {
      const isUser= ref(false);
      return {
        isAuthNb: useObservable(
          from(
          liveQuery(async () => {
            return await AppStates.getAuthNumberLive();
          })
          )
        ),
        isUser: useObservable(
          from(
            liveQuery(async () => {
               return await AppStates.getMyUserLive();
            })
          )
        ),
      };
    }
  }
  
